const accordionHolders = document.querySelectorAll(".accordion-holder");
if (accordionHolders && accordionHolders.length)
  accordionHolders.forEach((holder) => {
    const questions = holder.querySelectorAll(".c-accordion__header");

    if (questions && questions.length) {
      const answers = holder.querySelectorAll(".c-accordion__body");
      if (answers[0].closest(".c-accordion").classList.contains("active")) {
        answers[0].style.maxHeight = answers[0].scrollHeight + "px";
      }
      questions.forEach((question) => {
        const questionContainer = question.closest(".c-accordion");
        const panel = questionContainer.querySelector(".c-accordion__body");
        question.addEventListener("click", () => {
          questions.forEach((item) => {
            if (item !== question) {
              item.closest(".c-accordion").classList.remove("active");
              const itemsContainer = item.closest(".c-accordion");
              const text = itemsContainer.querySelector(".c-accordion__body");
              text.style.maxHeight = null;
            }
          });

          questionContainer.classList.toggle("active");
          if (questionContainer.classList.contains("active")) {
            panel.style.maxHeight = panel.scrollHeight + "px";
          } else {
            panel.style.maxHeight = null;
          }
        });
      });
    }
  });
